import { isEnvDefinedOrThrow } from '@hublo/configuration/utils'

import { basePath } from '../config/basePath'
import type { FrontendRuntimeConfig } from '../types'

/* we cannot use our getOrFail/getOrDefault existing helpers because NEXT_PUBLIC_ env vars
  are not recognized if not directly accessed from process.env
  https://nextjs.org/docs/pages/building-your-application/configuring/environment-variables#bundling-environment-variables-for-the-browser
*/

export const getRuntimeConfig = () => {
  const publicRuntimeConfig = {
    basePathWithoutSlash: basePath.endsWith('/')
      ? basePath.substring(0, basePath.length - 1)
      : basePath,
    //Base Monorepo Url
    monorepoBaseUrl: isEnvDefinedOrThrow(
      process.env.NEXT_PUBLIC_MONOREPO_BASE_URL,
      'NEXT_PUBLIC_MONOREPO_BASE_URL',
    )
      ? process.env.NEXT_PUBLIC_MONOREPO_BASE_URL
      : '',

    //BFF's
    monorepoBffWorkerURL: isEnvDefinedOrThrow(
      process.env.NEXT_PUBLIC_BFF_WORKER_URL,
      'NEXT_PUBLIC_BFF_WORKER_URL',
    )
      ? process.env.NEXT_PUBLIC_BFF_WORKER_URL
      : '',
    usePhraseEditor: process.env.NEXT_PUBLIC_USE_PHRASE_EDITOR ?? 'false',
    serviceTranslationsUrl: isEnvDefinedOrThrow(
      process.env.NEXT_PUBLIC_SERVICE_TRANSLATIONS_URL,
      'NEXT_PUBLIC_SERVICE_TRANSLATIONS_URL',
    )
      ? process.env.NEXT_PUBLIC_SERVICE_TRANSLATIONS_URL
      : '',
    serviceAppUrl: isEnvDefinedOrThrow(
      process.env.NEXT_PUBLIC_SERVICE_APP_URL,
      'NEXT_PUBLIC_SERVICE_APP_URL',
    )
      ? process.env.NEXT_PUBLIC_SERVICE_APP_URL
      : '',
    serviceApiUrl: isEnvDefinedOrThrow(
      process.env.NEXT_PUBLIC_SERVICE_API_URL,
      'NEXT_PUBLIC_SERVICE_API_URL',
    )
      ? process.env.NEXT_PUBLIC_SERVICE_API_URL
      : '',
    serviceInstitutionUrl: isEnvDefinedOrThrow(
      process.env.NEXT_PUBLIC_SERVICE_INSTITUTION_URL,
      'NEXT_PUBLIC_SERVICE_INSTITUTION_URL',
    )
      ? process.env.NEXT_PUBLIC_SERVICE_INSTITUTION_URL
      : '',
    serviceLandingUrl: isEnvDefinedOrThrow(
      process.env.NEXT_PUBLIC_SERVICE_LANDING_URL,
      'NEXT_PUBLIC_SERVICE_LANDING_URL',
    )
      ? process.env.NEXT_PUBLIC_SERVICE_LANDING_URL
      : '',
    monorepoBffAdminURL: isEnvDefinedOrThrow(
      process.env.NEXT_PUBLIC_SERVICE_MONOREPO_ADMIN_URL,
      'NEXT_PUBLIC_SERVICE_MONOREPO_ADMIN_URL',
    )
      ? process.env.NEXT_PUBLIC_SERVICE_MONOREPO_ADMIN_URL
      : '',
    monorepoServiceAdminUrl: isEnvDefinedOrThrow(
      process.env.NEXT_PUBLIC_SERVICE_MONOREPO_ADMIN_URL,
      'NEXT_PUBLIC_SERVICE_MONOREPO_ADMIN_URL',
    )
      ? process.env.NEXT_PUBLIC_SERVICE_MONOREPO_ADMIN_URL
      : '',
    monorepoServiceWorkerUrl: isEnvDefinedOrThrow(
      process.env.NEXT_PUBLIC_SERVICE_MONOREPO_WORKER_URL,
      'NEXT_PUBLIC_SERVICE_MONOREPO_WORKER_URL',
    )
      ? process.env.NEXT_PUBLIC_SERVICE_MONOREPO_WORKER_URL
      : '',
    monorepoServiceConfigUrl: isEnvDefinedOrThrow(
      process.env.NEXT_PUBLIC_SERVICE_MONOREPO_CONFIG_URL,
      'NEXT_PUBLIC_SERVICE_MONOREPO_CONFIG_URL',
    )
      ? process.env.NEXT_PUBLIC_SERVICE_MONOREPO_CONFIG_URL
      : '',
    monorepoServiceInstitutionUrl: isEnvDefinedOrThrow(
      process.env.NEXT_PUBLIC_SERVICE_MONOREPO_INSTITUTION_URL,
      'NEXT_PUBLIC_SERVICE_MONOREPO_INSTITUTION_URL',
    )
      ? process.env.NEXT_PUBLIC_SERVICE_MONOREPO_INSTITUTION_URL
      : '',
    monorepoServiceMissionUrl: isEnvDefinedOrThrow(
      process.env.NEXT_PUBLIC_SERVICE_MONOREPO_MISSION_URL,
      'NEXT_PUBLIC_SERVICE_MONOREPO_MISSION_URL',
    )
      ? process.env.NEXT_PUBLIC_SERVICE_MONOREPO_MISSION_URL
      : '',
    serviceAuthUrl: isEnvDefinedOrThrow(
      process.env.NEXT_PUBLIC_SERVICE_AUTH_URL,
      'NEXT_PUBLIC_SERVICE_AUTH_URL',
    )
      ? process.env.NEXT_PUBLIC_SERVICE_AUTH_URL
      : '',
    monorepoServiceFeatureTogglesUrl: isEnvDefinedOrThrow(
      process.env.NEXT_PUBLIC_SERVICE_FEATURE_TOGGLES_URL,
      'NEXT_PUBLIC_SERVICE_FEATURE_TOGGLES_URL',
    )
      ? process.env.NEXT_PUBLIC_SERVICE_FEATURE_TOGGLES_URL
      : '',
    monorepoServiceNotificationUrl: isEnvDefinedOrThrow(
      process.env.NEXT_PUBLIC_SERVICE_MONOREPO_NOTIFICATION_URL,
      'NEXT_PUBLIC_SERVICE_MONOREPO_NOTIFICATION_URL',
    )
      ? process.env.NEXT_PUBLIC_SERVICE_MONOREPO_NOTIFICATION_URL
      : '',
    mstaffUrl: isEnvDefinedOrThrow(
      process.env.NEXT_PUBLIC_MSTAFF_URL,
      'NEXT_PUBLIC_MSTAFF_URL',
    )
      ? process.env.NEXT_PUBLIC_MSTAFF_URL
      : '',
    segmentWriteKey: isEnvDefinedOrThrow(
      process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY,
      'NEXT_PUBLIC_SEGMENT_WRITE_KEY',
    )
      ? process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY
      : '',
    axeptioClientId: isEnvDefinedOrThrow(
      process.env.NEXT_PUBLIC_AXEPTIO_CLIENT_ID,
      'NEXT_PUBLIC_AXEPTIO_CLIENT_ID',
    )
      ? process.env.NEXT_PUBLIC_AXEPTIO_CLIENT_ID
      : '',

    // Dev only
    bypassLaunchdarkly: process.env.NEXT_PUBLIC_BYPASS_LAUNCHDARKLY ?? 'false',
    googleApiKey: isEnvDefinedOrThrow(
      process.env.NEXT_PUBLIC_GOOGLE_API_KEY,
      'NEXT_PUBLIC_GOOGLE_API_KEY',
    )
      ? process.env.NEXT_PUBLIC_GOOGLE_API_KEY
      : '',

    // file size
    maxDocumentSize: Number(
      isEnvDefinedOrThrow(
        process.env.NEXT_PUBLIC_MAX_DOCUMENT_SIZE,
        'NEXT_PUBLIC_MAX_DOCUMENT_SIZE',
      )
        ? process.env.NEXT_PUBLIC_MAX_DOCUMENT_SIZE
        : 0,
    ),

    //DataDog
    datadogRumApplicationId:
      process.env.NEXT_PUBLIC_DATADOG_RUM_APPLICATION_ID ?? '',
    datadogRumClientToken:
      process.env.NEXT_PUBLIC_DATADOG_RUM_CLIENT_TOKEN ?? '',
    datadogRumAppVersion: process.env.NEXT_PUBLIC_DATADOG_RUM_APP_VERSION ?? '',
    datadogRumSessionSample:
      process.env.NEXT_PUBLIC_DATADOG_RUM_SESSION_SAMPLE ?? '',

    //customerIO
    customerIOWriteKey: process.env.NEXT_PUBLIC_CUSTOMER_IO_WRITE_KEY ?? '',
    customerIOSiteId: process.env.NEXT_PUBLIC_CUSTOMER_IO_SITE_ID ?? '',

    //segment new values
    segmentApiKeyCaregivers:
      process.env.NEXT_PUBLIC_SEGMENT_API_KEY_CAREGIVERS ?? '',
    hubloCdpCdnUrl: process.env.NEXT_PUBLIC_HUBLO_CDP_CDN_URL ?? '',

    //posthog
    posthogApiKey: process.env.NEXT_PUBLIC_POSTHOG_KEY ?? '',
    posthogHost: process.env.NEXT_PUBLIC_POSTHOG_HOST ?? '',

    //deploy environment
    deployEnvironment: process.env.NEXT_PUBLIC_DEPLOY_ENV ?? '',
    serviceContractUrl: isEnvDefinedOrThrow(
      process.env.NEXT_PUBLIC_SERVICE_CONTRACT_URL,
      'NEXT_PUBLIC_SERVICE_CONTRACT_URL',
    )
      ? process.env.NEXT_PUBLIC_SERVICE_CONTRACT_URL
      : '',
    serviceDashboardUrl: isEnvDefinedOrThrow(
      process.env.NEXT_PUBLIC_SERVICE_DASHBOARD_URL,
      'NEXT_PUBLIC_SERVICE_DASHBOARD_URL',
    )
      ? process.env.NEXT_PUBLIC_SERVICE_DASHBOARD_URL
      : '',
    serviceBackofficeUrl: isEnvDefinedOrThrow(
      process.env.NEXT_PUBLIC_SERVICE_BACKOFFICE_URL,
      'NEXT_PUBLIC_SERVICE_BACKOFFICE_URL',
    )
      ? process.env.NEXT_PUBLIC_SERVICE_BACKOFFICE_URL
      : '',
    googleRecaptchaToken: isEnvDefinedOrThrow(
      process.env.NEXT_PUBLIC_RECAPTCHA_TOKEN,
      'NEXT_PUBLIC_RECAPTCHA_TOKEN',
    )
      ? process.env.NEXT_PUBLIC_RECAPTCHA_TOKEN
      : '',
  } as FrontendRuntimeConfig
  return {
    public: publicRuntimeConfig,
  }
}
